import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { EnvironmentService } from '../environment/environment.service'

const defaultCraftEnvironment = 'misterGreenNetherlands'

interface LanguageObject {
    languages: string[]
}

@Injectable({
    providedIn: 'root',
})
export class CraftEnvironmentService {
    craftEnvironment$: BehaviorSubject<string>
    languages$: BehaviorSubject<LanguageObject>

    constructor(environmentService: EnvironmentService) {
        this.craftEnvironment$ = new BehaviorSubject<string>(
            environmentService.environment['craftEnvironment'] || defaultCraftEnvironment
        )
        this.languages$ = new BehaviorSubject<LanguageObject>(
            craftEnvironmentMap[environmentService.environment['craftEnvironment'] || defaultCraftEnvironment]
        )
    }
}

const craftEnvironmentMap = {
    misterGreenNetherlands: {
        languages: ['nl'],
    },
    misterGreenBelgiumDutch: {
        languages: ['nl', 'fr'],
    },
    mistergreenBelgiumFrench: {
        languages: ['nl', 'fr'],
    },
}
